import React, {useState, useContext, useEffect} from 'react';
import styled from 'styled-components';
import BodyKnowledgeDescription from '../BodyKnowledgeDescription';
import {navigationIcCheck24px, navigationIcClose24px} from '@ey/motif-react-wrapper/assets/icons/index';
import {createRequestURL, createUpdatePayload} from '../Common/BodyResponseUtility';
import {labels, isEnterKeyPressed, GetCardTypeForBody} from '../../../../../util/utils';
import {formBodyType, keyCode} from '../../../../../util/uiconstants';
import {DocumentTypeIdContext, DocumentEngagementIdContext} from '../../../../Main/Forms/CanvasFormContainer';
import {FormBodyChangesContext} from '../FormBodyChangesWatcher';
import Label from '../../../BaseComponentWrappers/MotifLabel';
import ProgressBar from '../../../BaseComponentWrappers/MotifProgressBar';
import Icon from '../../../BaseComponentWrappers/MotifIcon';
import FormField from '../../../BaseComponentWrappers/MotifFormField';
import {useIsAresView} from '../../../../../util/Ares/customHooks';
import uuidv4 from 'uuid/v4';
import {useDocumentId, useEngagementId} from '../../../../../util/customHooks';
import Input from '../../../BaseComponentWrappers/MotifInput';

let currentSingleBodyId = undefined;
export default function SingleLineInput(props) {
	const {
		showGuidance,
		guidanceFilter,
		options,
		headerId,
		sectionId,
		bodyId,
		updateBodyOptions,
		getBodiesBySectionId,
		isSnapshotView,
		maxlength,
		customPlaceholder,
		callback,
		setInputEditing,
		isViewportBody,
		isDisabled
	} = props;

	const isAresView = useIsAresView();

	const _isDisabled = isSnapshotView || isDisabled;

	const initialValue = options?.bodyFreeText;

	const {resetChanges, onBodyValueChanged} = useContext(FormBodyChangesContext),
		engagementId = useEngagementId(),
		documentId = useDocumentId(),
		documentEngagementId = useContext(DocumentEngagementIdContext),
		documentTypeId = useContext(DocumentTypeIdContext);
	const elementName = `${headerId}-${sectionId}-${bodyId}`;

	const [text, setRichText] = useState(initialValue),
		[inputEdit, setInputEdit] = useState(false),
		[count, setCount] = useState(initialValue ? initialValue.length : 0);

	const formBodyBorder = GetCardTypeForBody(options, isAresView);

	const removeLoading = () => {
		document.getElementById(bodyId).classList.remove('greyOutArea');
	};

	const checkCallbackFunction = () => {
		const textValue = getValue().trim();
		setInputEdit(true);
		document.getElementById(bodyId).classList.add('greyOutArea');
		callback ? callback(textValue, removeLoading) : saveInputEdit();
	};

	const saveChanges = (e) => {
		const value = e.currentTarget.value;
		onBodyValueChanged(bodyId, initialValue, value, elementName);
		setRichText(value);
		setCount(value.length);
	};

	const editInput = (e) => {
		options?.bodyTypeId !== formBodyType.SingleLineInput && Number(engagementId) !== Number(documentEngagementId)
			? setInputEdit(false)
			: setInputEdit(true);
	};

	const saveInputEdit = () => {
		currentSingleBodyId = bodyId;
		setRichText(getValue().trim());
		document.getElementById(bodyId).classList.add('greyOutArea');
		if (!callback) {
			setInputEdit(true);
			const bodyResponseObject = createUpdatePayload(options?.bodyTypeId, text?.trim());
			updateBodyOptions(
				bodyId,
				0,
				createRequestURL(engagementId, documentId, headerId, sectionId, bodyId, documentTypeId),
				bodyResponseObject
			);
			resetChanges(bodyId, elementName);
		} else {
			checkCallbackFunction();
		}
	};

	const closeInputEdit = () => {
		setRichText(initialValue);
		setInputEdit(false);
		resetChanges(bodyId, elementName);
	};

	const getValue = () => {
		if (!inputEdit) {
			let formattedText = text === null ? '' : text;

			if (_isDisabled && formattedText === '') {
				formattedText = labels.singleLineValuePlaceholder;
			}
			return formattedText;
		} else {
			if (text === null) {
				return '';
			} else {
				return text;
			}
		}
	};

	const handleKeyDown = (e) => {
		if (isEnterKeyPressed(e)) {
			e.preventDefault();
			saveInputEdit();
			e.currentTarget.blur();
		} else if (e.keyCode === keyCode.ESCAPE) {
			closeInputEdit();
		}
	};

	useEffect(() => {
		if (bodyId === currentSingleBodyId) {
			setRichText(initialValue);
			setInputEdit(false);
			setCount(initialValue ? initialValue.length : 0);
		}
	}, [options]);

	useEffect(() => {
		const text = getValue();
		const checkEditInput = inputEdit || !!text;
		setInputEditing && setInputEditing(checkEditInput);
	}, [inputEdit]);

	const buildSuffix = () => {
		return (
			<section className="editInputIconWrapper" key={uuidv4()}>
				<span className="inputMotifIcon saveBtn" onClick={checkCallbackFunction}>
					<Icon src={navigationIcCheck24px} title={labels.saveLabel} />
				</span>
				<span className="inputMotifIcon cancelBtn" onClick={closeInputEdit}>
					<Icon src={navigationIcClose24px} title={labels.cancelLabel} />
				</span>
			</section>
		);
	};

	return (
		<Wrapper
			className={`SectionBodyWrapper singleLineInputBody ${formBodyBorder} ${isViewportBody ? 'BodyViewport' : ''}`}
		>
			{options?.name && (
				<BodyKnowledgeDescription
					isAresView={isAresView}
					showGuidance={showGuidance}
					guidanceFilter={guidanceFilter}
					isSnapshotView={_isDisabled}
					bodyModel={options}
					engagementId={engagementId}
					documentId={documentId}
					headerId={headerId}
					sectionId={sectionId}
					bodyId={bodyId}
					bodyDescriptionText={options.name}
					isCustom={options.isCustom}
					isDuplicate={options.isDuplicate}
					getBodiesBySectionId={getBodiesBySectionId}
				/>
			)}
			<section className="SectionBodyData SingleLineInputBodyData" id={bodyId}>
				{!_isDisabled ? (
					<section className="inputFieldWrapper">
						<section className="MotifProgressBarWrapper">
							<ProgressBar isIndeterminate circle hideLabel labelComponent={<span>{labels.saving}</span>} />
						</section>
						<section className="TextAreaEditorWrapper">
							<FormField className={`inputField SingleLineInput ${getValue() && 'hasValue'}`}>
								<Label position="in">{labels.singleLineValuePlaceholder}</Label>
								<Input
									id={bodyId.toString()}
									autocomplete="off"
									maxLength={500}
									value={getValue()}
									title={getValue()}
									onChange={saveChanges}
									onClick={editInput}
									onKeyDown={handleKeyDown}
									suffix={inputEdit && buildSuffix()}
									autoFocus={false}
								/>
							</FormField>
						</section>
					</section>
				) : (
					getValue()
				)}
			</section>
		</Wrapper>
	);
}

const Wrapper = styled.section`
	display: block;
	.SingleLineInputBodyData {
		background-color: var(--neutrals-00white);
		padding: var(--px-24);
		border: var(--px-1) solid var(--neutrals-200) !important;
		margin-top: var(--px-20) !important;
		&.greyOutArea {
			.inputFieldWrapper {
				.MotifProgressBarWrapper {
					.motif-progress-bar-wrapper {
						.motif-progress-bar {
							width: var(--px-20);
							height: var(--px-20);
						}
					}
				}
				.TextAreaEditorWrapper {
					opacity: 0.5;
				}
				.editInputIconWrapper {
					opacity: 0.2;
					.saveBtn,
					.cancelBtn {
						pointer-events: none;
					}
				}
			}
		}
	}
	.motif-tooltip-wrapper {
		width: calc(100% - var(--px-30));
	}
	.inputFieldWrapper {
		background-color: var(--neutrals-00white);
		position: relative;
		display: flex;
		flex-direction: column;
		width: var(--px-461);
		.MotifProgressBarWrapper {
			display: none;
			position: absolute;
			justify-content: center;
			width: 92%;
			height: 100%;
			.motif-progress-bar-wrapper {
				height: 100%;
				z-index: 1;
				justify-content: center;
				span {
					color: var(--green-500);
					font-size: var(--px-12);
				}
				.motif-progress {
					background-color: var(--green-500);
				}
			}
		}
		.TextAreaEditorWrapper {
			display: flex;
			flex-direction: column;
			width: 100%;
			.motif-form-field {
				width: 100%;
				height: calc(100% - var(--px-20)) !important;
			}
		}
		.pull-right-counter {
			margin: 0;
			text-align: right;
			font-size: var(--px-11);
			height: var(--px-25);
			font-size: var(--px-12);
			font-weight: 300;
			line-height: var(--px-20);
			color: var(--neutrals-900);
		}
		.editInputIconWrapper {
			display: inline-flex;
			align-items: center;
			justify-content: flex-end;
			padding: var(--px-8) 0 var(--px-8) var(--px-13);
			height: auto;
			.inputMotifIcon {
				color: var(--neutrals-700);
				&.saveBtn,
				&.cancelBtn {
					.motif-icon {
						svg {
							width: var(--px-20);
							height: var(--px-20);
							margin-right: var(--px-10);
							fill: var(--neutrals-700);
							path {
								fill: var(--neutrals-700);
							}
						}
					}
				}
			}
		}
		&.inputFieldWithNoLabel {
			.motif-label {
				display: none;
			}
			.motif-input {
				padding: 0 !important;
				height: 100%;
			}
		}
	}
`;
